<template>
  <el-dialog
          :title="'详情'"
          :close-on-click-modal="false"
          :visible.sync="visible"
  style="text-align: left">
    <el-form  ref="dataForm"
             label-width="150px">
        <el-row>
            <el-col :span="12">
                <el-form-item label="固定资产编号" prop="assetNumber">
                    <div class="min-input-class">{{asset.assetNumber}}</div>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="名称" prop="name">
                    <div class="min-input-class">{{asset.name}}</div>
                </el-form-item>
            </el-col>
        </el-row>

        <el-row>
            <el-col :span="12">

                <el-form-item label="类别编号" prop="typeNumber">
                    <div class="min-input-class">{{asset.typeNumber}}</div>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="类别" prop="assetTypeId">
                    <div class="min-input-class">
                        <el-tag type="success">{{asset.typeName}}</el-tag>
                    </div>
                </el-form-item>
            </el-col>
        </el-row>

        <el-row>
            <el-col :span="12">
                <el-form-item label="型号规格" prop="specification">
                    <div class="min-input-class">{{asset.specification}}</div>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="部门" prop="deptId">
                    <div class="min-input-class">
                        <el-tag type="success">{{asset.bmmc}}</el-tag></div>
                </el-form-item>
            </el-col>
        </el-row>

        <el-row>
            <el-col :span="12">
                <el-form-item label="增加方式" prop="addType">
                    <div class="min-input-class">{{asset.addType}}</div>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="使用人" prop="addType">
                    <div class="min-input-class">{{asset.syrxm}}</div>
                </el-form-item>
            </el-col>
        </el-row>

        <el-row>
            <el-col :span="12">
                <el-form-item label="使用状况" prop="useState">
                    <div class="min-input-class">{{asset.useState}}</div>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="存放地点" prop="stroagePostion">
                    <div class="min-input-class">{{asset.stroagePostion}}</div>
                </el-form-item>
            </el-col>
        </el-row>
        
        <el-row>
            <el-col :span="12">
                <el-form-item label="使用年限(年)" prop="allUseTimeYear">
                    <div class="min-input-class">{{asset.allUseTimeYear}}</div>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="使用年限(月)" prop="allUseTimeMonth">
                    <div class="min-input-class">{{asset.allUseTimeMonth}}</div>
                </el-form-item>
            </el-col>
        </el-row>

        <el-row>
            <el-col :span="12">
                <el-form-item label="登记时间" prop="time">
                    <div class="min-input-class">{{asset.time}}</div>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="开始使用日期" prop="beginUseTime">
                    <div class="min-input-class">{{asset.beginUseTime}}</div>
                </el-form-item>
            </el-col>
        </el-row>

        <el-row>
            <el-col :span="12">
                <el-form-item label="可抵扣税额" prop="kdkse">
                    <div class="min-input-class">{{asset.kdkse}}</div>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="币种" prop="currency">
                    <div class="min-input-class">
                        <el-tag v-if="asset.currency==0" type="success">人民币</el-tag>
                    </div>
                </el-form-item>
            </el-col>
        </el-row>

        <el-row>
            <el-col :span="12">
                <el-form-item label="原值" prop="yz">
                    <div class="min-input-class">{{toThousands(asset.yz)}}</div>
                </el-form-item>
            </el-col>
            <el-col :span="12" v-if="asset.method===0">
                <el-form-item label="净残值率(%)" prop="jczl">
                    <div class="min-input-class">{{asset.jczl}}</div>
                </el-form-item>
            </el-col>
            <el-col :span="12" v-else-if="asset.method===1">
                <el-form-item label="报废日期" prop="jczl">
                    <div class="min-input-class">{{asset.bfrq}}</div>
                </el-form-item>
            </el-col>
        </el-row>

        <el-row v-if="asset.method===0">
            <el-col :span="12">
                <el-form-item label="净残值" prop="jcz">
                    <div class="min-input-class">{{toThousands(asset.jcz)}}</div>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="已计提月份" prop="hasUseMonth">
                    <div class="min-input-class">{{asset.hasUseMonth}}</div>
                </el-form-item>
            </el-col>
        </el-row>

        <el-row v-if="asset.method===0">
            <el-col :span="12">
                <el-form-item label="累计折旧" prop="ljzj">
                    <div class="min-input-class">{{asset.ljzj}}</div>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="净值" prop="jz">
                    <div class="min-input-class">{{asset.jz}}</div>
                </el-form-item>
            </el-col>
        </el-row>

        <el-row v-if="asset.method==0">
            <el-col :span="12">
                <el-form-item label="月折旧率" prop="yzjl">
                    <div class="min-input-class">{{asset.yzjl}}</div>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="月折旧额" prop="yzje">
                    <div class="min-input-class">{{asset.yzje}}</div>
                </el-form-item>
            </el-col>
        </el-row>

        <el-row>
            <el-col :span="12">
                <el-form-item label="对应折旧科目" prop="dyjzkm">
                    <div class="min-input-class">{{asset.dyjzkm}}</div>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="折旧方法" prop="method">
                    <div class="min-input-class" >
                        <el-tag type="success" v-if="asset.method===0">平均年限法</el-tag>
                        <el-tag  v-else-if="asset.method===1">直接报废法</el-tag>
                    </div>
                </el-form-item>
            </el-col>
        </el-row>
        
        <el-row>
            <el-col :span="12">
                <el-form-item label="项目" prop="project">
                    <div class="min-input-class">{{asset.project}}</div>
                </el-form-item>
            </el-col>
        </el-row>

    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import Template from "@/template";
  export default {
      components: {Template},
      data () {

      return {
        visible: false,
        asset: {},
        workerConfig:[]
      }
    },
    methods: {
      init (id) {
        if(!id) return;
        this.visible = true
        this.$nextTick(() => {
            this.asset = id
        })

      },
        toThousands(num) {
            var result = [ ], counter = 0;
            num = (num || 0).toString().split('');
            for (var i = num.length - 1; i >= 0; i--) {
                counter++;
                result.unshift(num[i]);
                if (!(counter % 3) && i != 0 && num[i] !='.') { result.unshift(','); }
            }
            return result.join('');
        }
    }
  }
</script>
<style lang="scss" scoped>
    .min-input-class {

        min-height:25px;
        border-bottom:1px dotted  #b0b1b3;
    }
</style>
